import { MultiFieldDynamicFields } from '../multiFieldDynamicFields';
import { FormikProps } from 'formik';
import { MultiDynamicField } from '../../../../../shared/types/assistant';

export const StyleAndTonality = ({
    formikStyleAndTonality,
}: {
    formikStyleAndTonality: FormikProps<{ [key: string]: MultiDynamicField[] }>;
}) => {
    return (
        <MultiFieldDynamicFields
            formik={formikStyleAndTonality}
            name="styleAndTonality"
            label="Estilo y Tonalidad"
            description="Define cómo debe expresarse tu asistente, estableciendo un equilibrio entre cercanía y formalidad en el lenguaje, incluyendo el tono de comunicación, técnicas de explicación y la estructura de las respuestas."
            example={{
                title: 'Cercano pero Formal',
                description:
                    'Mantener un tono institucional, pero con cercanía.',
            }}
        />
    );
};
